(() => {
  const init = (root) => {
    if (!root || root.dataset.evwImagePerformance === 'true') return;
    root.dataset.evwImagePerformance = 'true';
    const slides = [...root.querySelectorAll('[data-evw-slide]')];
    if (slides.length < 2 || navigator.connection?.saveData) return;
    const warm = (index) => {
      const image = slides[(index + slides.length) % slides.length]?.querySelector('img');
      if (!image || image.dataset.evwWarm === 'true') return;
      image.dataset.evwWarm = 'true';
      image.loading = 'eager';
      try { image.fetchPriority = 'low'; } catch (_) {}
    };
    const first = slides[0]?.querySelector('img');
    const schedule = () => {
      if ('requestIdleCallback' in window) requestIdleCallback(() => warm(1), { timeout: 1200 });
      else setTimeout(() => warm(1), 350);
    };
    if (first && !first.complete) first.addEventListener('load', schedule, { once: true }); else schedule();
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-evw-final]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true }); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
